module.exports = __webpack_public_path__ + "static/media/workspaceSelected.aa0d6592.png";